<!--理财-->
<template>
    <div class="id">
        <div class="head">
            <div style="display: flex;align-items: center">
                <div>{{ $t('投资组合') }}</div>
                <div style="font-size: 14px; padding-left: 20px;">
                    <span>{{ $t('当前团队等级') }}</span>
                    <span style="padding: 0 5px;">V{{ teamLevel }}</span>
                </div>
            </div>
            <span style="color: #00f0ff" @click="$router.push(`/mobile/grade`)">{{ $t('等级规则') }}</span>
        </div>
        <div style="display: flex;align-items: center;justify-content: space-between;">
            <div class="box">
                <van-image width="60" height="60" :src="defaultCoin.image" />
                <div style=" margin-top: 6px;padding-left: 10px;">
                    <div>{{ defaultCoin.symbol }}</div>
                    <div class="income">
                        <div>{{ defaultCoin.total_profit }}</div>
                        <div style="margin-top: 4px;">{{ $t('总收益') }}</div>
                    </div>
                </div>
            </div>
            <span style="color: #00f0ff" @click="$router.push(`/mobile/order`)">{{ $t('投资订单') }}</span>
        </div>
        <div class="currency">
            <div class="itemS" v-for="value in productList" :key="value.id">
                <div>{{ value.symbol }}</div>
                <div class="Amount">
                    <van-image height="18" width="24" :src="value.image" />
                    <div>{{ value.price }}</div>
                </div>
            </div>
        </div>
        <div class="contentS" v-for="(item, index) in list" :key="index">
            <van-image width="100" v-if="item.hot == 1" :src="require('@/assets/img/icon/icon2.svg')" class="img" />
            <div>{{ item.invest }}</div>
            <div style="padding-top: 6px; color: #ababb2;">{{ $t('投资金额') }}:{{ item.amount }}-{{ item.amax }}</div>
            <van-image width="100%" height="140" :src="item.bg_image" />
            <div class="contentBox">
                <div style="font-size:18px;">{{ $t('收益率') }}</div>
                <div class="boxW">{{ $t('时长') }}: {{ item.days }}{{ $t('日') }}</div>
            </div>
            <div class="contentBox" style="padding: 10px 0;align-items:flex-end">
                <div style="font-size: 18px;">{{ item.ratemax }}% / {{ $t('天') }}</div>
                <div style="padding-left: 20px;">{{ $t('剩余次数') }}:{{ item.remaining_number }}</div>
            </div>
            <div class="btn" @click="combineInfo(item)">{{ $t('参与使用') }}</div>
        </div>

        <van-popup v-model="showPopup" closeable position="bottom" round :style="{ height: '90%' }">
            <div class="popupId">
                <div class="title">
                    <div class="icon"></div>
                    <div>{{ $t('确认组合') }}</div>
                </div>
                <div class="combination">
                    <div class="item" v-for="item in rowList" :key="item.id">
                        <van-image width="40" :src="item.image" />
                        <div style="padding: 0px 5px; padding-top: 10px;">
                            <div style="padding: 4px 0;">{{ item.symbol }}</div>
                            <div :style="{ color: item.price_zf > 0 ? '#00f0e0' : '#ff341f' }">{{ item.price_zf > 0 ?
                                '+' + item.price_zf :
                                item.price_zf }}</div>
                        </div>
                    </div>
                </div>
                <div style="padding: 20px 0;">
                    <div class="Details">
                        <div>{{ $t('运行时常') }}</div>
                        <div>{{ days }}{{ $t('天') }}</div>
                    </div>
                    <div class="Details">
                        <div>{{ $t('日收益率') }}</div>
                        <div>{{ ratemax }}%</div>
                    </div>
                    <div class="Details">
                        <div>{{ $t('预估收益') }}</div>
                        <div>{{ estimate }}USDT</div>
                    </div>
                    <div class="Details">
                        <div>{{ $t('投资金额') }}</div>
                        <div>{{ amount }} - {{ amax }}USDT</div>
                    </div>
                    <div class="Details">
                        <div>{{ $t('手续费') }}</div>
                        <div>{{ commission }}USDT</div>
                    </div>
                </div>
                <div class="title">
                    <div class="icon"></div>
                    <div>{{ $t('申请金额') }}</div>
                </div>
                <div class="universal">
                    <van-field v-model="quantity" :placeholder="$t('请输入投资金额')" :border="false" @input="fieldC" />
                    <div style="color: #07ecfe;white-space: nowrap;">USDT</div>
                </div>
                <div style="padding: 10px 0;">
                    <span style="color: #888;">{{ $t('账户余额') }}：</span> {{ earnAccount }} USDT
                </div>
                <van-button type="primary" class="bth" @click="Apply">{{ $t('申请') }}</van-button>
                <div class="title" style="padding-top: 20px;">
                    <div class="icon"></div>
                    <div>{{ richText.title }}</div>
                </div>
                <p style="color: #888;">{{ richText.content }}</p>
            </div>
        </van-popup>
        <Footer></Footer>
    </div>
</template>
<script>
import { get, post } from '@/http/request'
import Footer from '@/common/mobile/Footer.vue'

export default {
    components: {
        Footer
    },
    data() {
        return {
            showPopup: false,
            defaultCoin: {},
            list: [],
            productList: [],
            rowList: '',
            days: '',
            amount: '', //最小投资
            amax: '', //最大投资金额
            commission: "", //手续费
            earnAccount: "", //账户余额
            richText: {},
            ratemax: '',
            estimate: '0',//预估收益
            quantity: '',
            itemID: "",
            teamLevel: ''
        };
    },
    mounted() {
        this.quantCombineData()
        this.getUserInfo()
    },
    beforeUnmount() { },
    methods: {
        async quantCombineData() {
            const res = await get(this.$apis.getQuantCombineData)
            if (res.code == 1) {
                this.defaultCoin = res.data.default_coin
                this.list = res.data.list
                this.productList = res.data.product_list
                return
            }
        },

        async combineInfo(item) {
            console.log(item);
            this.itemID = item.id
            const res = await get(this.$apis.getQuantCombineInfo, { id: item.id })
            if (res.code == 1) {
                this.rowList = res.data.product_list
                this.days = res.data.days
                this.amount = res.data.amount
                this.amax = res.data.amax
                this.commission = res.data.commission
                this.earnAccount = res.data.earn_account
                this.richText = res.data.rich_text
                this.ratemax = res.data.ratemax
                this.showPopup = true
                return
            }
        },
        async getUserInfo() {
            const res = await get(this.$apis.getUserInfo)
            if (res.code == 1) {
				this.$store.commit('setUserInfo', res.data)
                this.teamLevel = res.data.team_level
                return
            }
        },
        fieldC() {
            console.log();
            this.estimate = (this.quantity * this.ratemax * this.days).toFixed(2)
        },

        async Apply() {
            const res = await post(this.$apis.quantOrderSubmit, {
                amount: this.quantity,
                id: this.itemID
            })
            if (res.code == 1) {
                this.$toast(this.$t('申请成功'));
                this.showPopup = false
                this.quantity = ''
                return
            }
        }

    },
};
</script>
<style lang="less" scoped>
::v-deep .van-cell {
    padding: 0;
}

.popupId {
    background-color: #1f1f2f;
    height: 90vh;
    padding: 20px;

    .bth {
        background-color: #00f0ff;
        color: #000;
        width: 100%;
        border-radius: 10px;
        margin: 10px 0;
    }

    .universal {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: 1px solid #3a3f47;
        margin-top: 10px;
        border-radius: 5px;
        background-color: #000;

        .address {
            width: 85%;
            word-break: break-all;
        }
    }

    .title {
        display: flex;
        align-items: center;
        font-size: 18px;

        .icon {
            width: 8px;
            height: 8px;
            border-radius: 2px;
            background: #00f0ff;
            margin-right: 5px;
        }
    }

    .combination {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 15px;

        .item {
            width: 30%;
            padding: 15px 10px;
            background: #2c2c3e;
            border-radius: 10px;
            font-size: 15px;
        }
    }

    .Details {
        display: flex;
        justify-content: space-between;
        padding: 6px 0;
        font-size: 14px;

        div:nth-child(1) {
            color: #888888
        }
    }


}

.id {
    color: #fff;
    padding: 0 15px;
    padding-bottom: 60px;
    padding-top: 50px;
    font-size: 14px;

    .head {
        padding: 15px 0;
        border-bottom: 1px solid #2f303d;
        display: flex;
        align-items: center;
        justify-content: space-between;

        div:nth-child(1) {
            font-size: 20px;
        }
    }

    .box {
        display: flex;
        align-items: center;
        padding: 15px 0;


        .income {
            display: flex;
            align-items: center;


            div:nth-child(1) {
                font-size: 35px;
            }

            div:nth-child(2) {
                background-color: #ff1843;
                padding: 2px 10px;
                border-radius: 20px;
                margin-left: 10px;
                font-size: 11px;

            }
        }
    }

    .currency {
        display: flex;
        justify-content: space-around;
        overflow-x: auto;
        -ms-overflow-style: none;
        /* IE/Edge */
        scrollbar-width: none;
        /* Firefox */

        .itemS {
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #888;
            padding-right: 20px;

            .Amount {
                display: flex;
                align-items: center;
                padding-top: 10px;
                font-size: 14px;
                font-weight: 700;
                color: #fff;

                div {
                    padding-left: 6px;
                }
            }
        }
    }

    .contentS {
        background-color: #2c2c3e;
        // height: 300px;
        border-radius: 20px;
        margin: 20px 0;
        padding: 15px;
        position: relative;

        .img {
            position: absolute;
            top: 0;
            right: 0;
        }

        .contentBox {
            display: flex;
            align-items: center;
            padding-top: 8px;

            .boxW {
                background-color: #ff3131;
                padding: 3px 6px;
                border-radius: 20px;
                margin-left: 10px;
                font-size: 11px;
            }
        }

        .btn {
            background-color: #00f0ff;
            color: #000;
            padding: 10px;
            text-align: center;
            border-radius: 40px;
            font-weight: 700;
        }
    }

}
</style>
